import React, { Component } from "react";
import { Modal, Button, Loader } from "semantic-ui-react";
import swal from "sweetalert2";
import { laravelService } from "../../utils/laravelService";
import { notify } from "react-notify-toast";
import ReactTable from "react-table";

export default class ProvidersContactModal extends Component {
  state = {
    contactos: [],
    loadingContactos: false,
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.isOpened &&
      (!prevProps.isOpened || this.props.client.id !== prevProps.client.id)
    ) {
      this.fetchContactos();
    }
  }

  fetchContactos = async () => {
    this.setState({ loadingContactos: true });

    try {
      const response = await laravelService.get(
        `proveedores/${this.props.client.id}/contactos`
      );
      this.setState({ contactos: response.data });
    } catch (error) {
      console.error("Error al obtener contactos", error);
      notify.show("Error al obtener contactos", "error");
    } finally {
      this.setState({ loadingContactos: false });
    }
  };

  render() {
    const { client, isOpened, onClose } = this.props;
    const { contactos, loadingContactos } = this.state;

    return (
      <Modal open={isOpened} size={"small"}>
        <Modal.Header style={{ backgroundColor: "#f3f3f3" }}>
          {client.nombre}
          <Button
            circular
            size="mini"
            basic
            icon="close"
            floated="right"
            onClick={onClose}
          />
        </Modal.Header>
        <Modal.Content>
          <div>
            {loadingContactos ? (
              <Loader
                active
                inline="centered"
                content="Cargando contactos..."
              />
            ) : contactos.length === 0 ? (
              <p>No hay contactos registrados.</p>
            ) : (
              <div style={{ marginTop: "2em" }}>
                <h4>Contactos</h4>
                <ReactTable
                  columns={[
                    {
                      Header: "Nombre",
                      accessor: "nombre_contacto",
                    },
                    {
                      Header: "Puesto",
                      accessor: "puesto_contacto",
                    },
                    {
                      Header: "Teléfono",
                      accessor: "whatsapp_telefono",
                    },
                    {
                      Header: "Email",
                      accessor: "email",
                    },
                  ]}
                  manual
                  data={contactos}
                  loading={loadingContactos}
                  defaultPageSize={10}
                  className="-striped -highlight"
                />
              </div>
            )}
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}
